console.log("EQUIPMENT UTILS LOADED", new Date().toISOString());

// Extract unique values from equipment data for dropdowns
export const extractDropdownOptions = (itemList) => {
    console.log("EXTRACTING OPTIONS FROM:", itemList);

    if (!itemList || !Array.isArray(itemList) || itemList.length === 0) {
        console.log("No equipment list data to extract options from");
        return { categories: [], makes: [], models: [] };
    }

    try {
        // Check if this is asset data by looking at the first item
        const firstItem = itemList[0];
        const isAssetData = firstItem && ('asset_type' in firstItem || 'asset_category' in firstItem);

        if (isAssetData) {
            console.log("Processing asset data for dropdown options");

            // Map asset fields to dropdown categories
            // UPDATED: Check for "brand" field for the "make" dropdown
            const categoryField = 'asset_type' in firstItem ? 'asset_type' : 'asset_category';
            const makeField = 'brand' in firstItem ? 'brand' :
                ('manufacturer' in firstItem ? 'manufacturer' : 'make');
            const modelField = 'model';

            console.log("Field mapping for asset data:", {
                categoryField,
                makeField,
                modelField
            });

            // Safely extract categories from assets
            const categories = [...new Set(itemList
                .filter(item => item && item[categoryField])
                .map(item => item[categoryField])
            )].sort();

            // Safely extract makes from assets - NOW CHECKING BRAND FIELD
            const makes = [...new Set(itemList
                .filter(item => item && item[makeField])
                .map(item => item[makeField])
            )].sort();

            // Safely extract models from assets
            const models = [...new Set(itemList
                .filter(item => item && item[modelField])
                .map(item => item[modelField])
            )].sort();

            console.log("Extracted categories from assets:", categories);
            console.log("Extracted makes from assets:", makes);
            console.log("Extracted models from assets:", models);

            return { categories, makes, models };
        } else {
            // Original equipment data processing
            // Safely extract categories
            const categories = [...new Set(itemList
                .filter(item => item && item.category)
                .map(item => item.category)
            )].sort();

            // Safely extract makes
            const makes = [...new Set(itemList
                .filter(item => item && item.make)
                .map(item => item.make)
            )].sort();

            // Safely extract models
            const models = [...new Set(itemList
                .filter(item => item && item.model)
                .map(item => item.model)
            )].sort();

            console.log("Extracted categories:", categories);
            console.log("Extracted makes:", makes);
            console.log("Extracted models:", models);

            return { categories, makes, models };
        }
    } catch (error) {
        console.error("Error extracting options:", error);
        return { categories: [], makes: [], models: [] };
    }
};

// Filter equipment based on selected category and make
export const filterEquipmentOptions = (equipmentList, filters) => {
    console.log("Filtering equipment with filters:", filters);

    if (!equipmentList || !Array.isArray(equipmentList) || equipmentList.length === 0) {
        console.log("No equipment list to filter");
        return [];
    }

    try {
        let filtered = [...equipmentList];

        // Check if we're dealing with asset data
        const isAssetData = filtered[0] && ('asset_type' in filtered[0] || 'asset_category' in filtered[0]);

        // Only apply filters that actually exist
        if (filters) {
            if (isAssetData) {
                // For asset data, map field names accordingly
                const categoryField = 'asset_type' in filtered[0] ? 'asset_type' : 'asset_category';
                const makeField = 'brand' in filtered[0] ? 'brand' :
                    ('manufacturer' in filtered[0] ? 'manufacturer' : 'make');
                const modelField = 'model';

                if (filters.category) {
                    filtered = filtered.filter(item => item && item[categoryField] === filters.category);
                }

                if (filters.make) {
                    filtered = filtered.filter(item => item && item[makeField] === filters.make);
                }

                if (filters.model) {
                    filtered = filtered.filter(item => item && item[modelField] === filters.model);
                }
            } else {
                // For equipment data, use standard field names
                if (filters.category) {
                    filtered = filtered.filter(item => item && item.category === filters.category);
                }

                if (filters.make) {
                    filtered = filtered.filter(item => item && item.make === filters.make);
                }

                if (filters.model) {
                    filtered = filtered.filter(item => item && item.model === filters.model);
                }
            }
        }

        console.log("Filtered equipment count:", filtered.length);
        return filtered;
    } catch (error) {
        console.error("Error filtering equipment:", error);
        return [];
    }
};

// Get options for a specific field based on current selections
export const getFilteredOptions = (equipmentList, field, filters) => {
    console.log(`Getting filtered options for ${field} with filters:`, filters);

    if (!field || !equipmentList || !Array.isArray(equipmentList)) {
        console.log("Missing required parameters for filtering");
        return [];
    }

    try {
        // Check if we're dealing with asset data
        const isAssetData = equipmentList[0] && ('asset_type' in equipmentList[0] || 'asset_category' in equipmentList[0]);

        // Map field names for asset data
        let actualField = field;
        if (isAssetData) {
            if (field === 'category') {
                actualField = 'asset_type' in equipmentList[0] ? 'asset_type' : 'asset_category';
            } else if (field === 'make') {
                // UPDATED: Check for "brand" field
                actualField = 'brand' in equipmentList[0] ? 'brand' :
                    ('manufacturer' in equipmentList[0] ? 'manufacturer' : 'make');
            }
        }

        console.log(`Field '${field}' mapped to '${actualField}' in data`);

        const filtered = filterEquipmentOptions(equipmentList, filters);

        const options = [...new Set(filtered
            .filter(item => item && item[actualField])
            .map(item => item[actualField])
        )].sort();

        console.log(`Filtered ${field} options:`, options);
        return options;
    } catch (error) {
        console.error(`Error getting filtered options for ${field}:`, error);
        return [];
    }
};